// extracted by mini-css-extract-plugin
export default {"cls1":"SearchUpsell-cls1__k_","cls2":"SearchUpsell-cls2_PYk SearchUpsell-cls1__k_"};